<template>
  <div class="tenant-table">
    <el-table
    height="200"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
    >
      <el-table-column
          :label="$translate('lang.E3202103110001', { defaultText: '租户代码' })"
          prop="tenantCode"
          :show-overflow-tooltip="true" >
      </el-table-column>
      <el-table-column
          prop="tenantName"
          :label="$translate('lang.E3202103110002', { defaultText: '租户名称' })"
          :show-overflow-tooltip="true" >
      </el-table-column>
      <el-table-column prop="clusterName"
          :label="$translate('lang.E3202103150004', { defaultText: 'ES集群' })"
          :show-overflow-tooltip="true" >
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
    props: {
        tableData: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            dialogVisible: false,
            tableList: null
        };
    },
    methods: {
        goIndex() {
            this.$router.push('/index');
        },
        nuwPush(row) {
            this.$emit('openEs', row);
        }
    }
};
</script>
<style lang="less">
.tenant-table{
  .el-table--border {
        border: 1px solid #EBEEF5;
    }
}
</style>